import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { usePriceGroup } from 'core/contexts/priceGroup';
import { Box, Button, Grid2, InputLabel } from '@mui/material';
import { SelectComponent } from '@utriper/core-ui';
import { Field, Form } from 'react-final-form';
import Title from '../../../components/Title';

const AddUnitForm = ({ handleClose = () => {} }) => {
    const { t, i18n } = useTranslation();
    const translate = (key) => t(`price_group_wizard.add_unit_form.${key}`);
    const { language } = i18n;
    const { getNewUnitTypes, addNewUnitOption, unitsOptions } = usePriceGroup();

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const typeOptions = useMemo(getNewUnitTypes, [language, unitsOptions]);
    const [submitted, setSubmitted] = useState(false);

    const validateForm = (values) => {
        const errors = {};

        if (!Number.isInteger(values?.typeId)) {
            errors.typeId = translate('validate_form');
        }

        return errors;
    };

    const handleSubmit = ({ typeId }) => {
        return addNewUnitOption(typeId, handleClose);
    };

    return (
        <Form
            onSubmit={handleSubmit}
            initialValues={''}
            validate={validateForm}
            render={({ errors, handleSubmit, form }) => {
                return (
                    <form onSubmit={handleSubmit} noValidate style={{ width: '100%' }}>
                        <Box component="section" py={2}>
                            <Title title={translate('title')} description={translate('description')} />
                            {/* Form */}
                            <Grid2 container width="100%" direction="column" justifyContent="flex-start" alignItems="flex-start" gap="8px" mt="24px">
                                <Grid2 container width="100%" direction="column" justifyContent="flex-start" alignItems="flex-start" gap="4px">
                                    <InputLabel
                                        sx={{
                                            fontSize: '18px',
                                            fontWeight: 400,
                                            color: '#131313',
                                        }}
                                    >
                                        {translate('form.unit')}
                                    </InputLabel>
                                    <Field name="typeId" component={SelectComponent} values={typeOptions} displayEmpty label={translate('form.unit')} hasError={submitted && errors?.priceType} errorMessage={errors?.priceType} />
                                </Grid2>
                            </Grid2>

                            {/* Action Buttons */}
                            <Grid2 container justifyContent={{ xs: 'center', md: 'flex-end' }} alignItems="center" gap="12px" mt="16px">
                                <Button
                                    sx={{
                                        padding: '8px 14px',
                                        borderColor: '#13131340',
                                        fontWeight: 700,
                                        width: { xs: '100%', md: 'fit-content' },
                                        textTransform: 'none',
                                    }}
                                    variant="outlined"
                                    onClick={(e) => {
                                        handleClose();
                                        return form.reset(e);
                                    }}
                                >
                                    {translate('form.cancel_button')}
                                </Button>
                                <Button
                                    sx={{
                                        padding: '8px 14px',
                                        backgroundColor: 'var(--color-utriper-blue)',
                                        fontWeight: 700,
                                        width: { xs: '100%', md: 'fit-content' },
                                        textTransform: 'none',
                                    }}
                                    variant="contained"
                                    type="submit"
                                    onClick={(e) => {
                                        setSubmitted(true);
                                        return handleSubmit(e);
                                    }}
                                >
                                    {translate('form.add_button')}
                                </Button>
                            </Grid2>
                        </Box>
                    </form>
                );
            }}
        />
    );
};

export default AddUnitForm;
